import AppIcons from '../icons';
import ToolbarIcons from '../icons/toolbar';
import React from 'react';

const en = {
  splash: 'Experience good moments',
  folderPart: {
    menu: [
      { id: 0, name: 'messages', fileType: 'message' },
      { id: 1, name: 'images', fileType: 'image' },
      { id: 2, name: 'videos', fileType: 'video' },
      { id: 3, name: 'musics', fileType: 'music' },
      { id: 4, name: 'files', fileType: 'pdf,doc' },
      { id: 5, name: 'other', fileType: 'zip,rar' },
    ],
  },
  reload: 'Reload app',
  signupText: 'Signup',
  offlineText: 'check yot internet connection',
  onlineStatus: 'online status',
  onlineStatusOn: 'Your online status is on.',
  onlineStatusOff: 'Your online status is off.',
  darkMode: 'dark mode',
  darkModeOn: 'dark mode in enabled.',
  darkModeOff: 'dark mode is disabled.',
  chatDemo: {
    you: 'you',
    yourText: 'I will inform you',
    contact: 'Jessy',
    contactText:
      'Lorem Epsom or blueprint is called an experimental and nonsensical text in the printing, page layout and graphic design industry. Graphic designer of this text as an element',
  },
  settingModal: {
    menu: [
      // { id: 1, name: 'choose theme' },
      // { id: 2, name: 'languages' },
      // { id: 3, name: 'background' },

      {
        id: 1,
        name: 'change theme',
        icon: (
          <ToolbarIcons.themeIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 2,
        name: 'languages',
        icon: (
          <ToolbarIcons.LanguageIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 3,
        name: 'background',
        icon: (
          <ToolbarIcons.backgroundIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 4,
        name: 'files',
        icon: (
          <ToolbarIcons.FileIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 5,
        name: 'edit profile',
        icon: (
          <ToolbarIcons.EditProfileIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 8,
        name: 'change password',
        icon: (
          <ToolbarIcons.changePasswordIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'18px'}
            height={'18px'}
          />
        ),
      },
      {
        id: 6,
        name: 'logout',
        icon: (
          <ToolbarIcons.ExitIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 7,
        name: 'delete account',
        icon: (
          <ToolbarIcons.DeleteAccount
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      // { id: 4, name: 'فایل‌ها' },
    ],
  },
  deleteAccount: {
    title: '',
    description: 'Are you sure you want to delete your account?',
    confirmText: 'Yes',
    rejectText: 'No',
  },
  deleteFav: {
    title: '',
    description:
      'Are you sure you want to delete the message from favorite list?',
    confirmText: 'Yes',
    rejectText: 'No',
  },
  // noContent: 'Select user to start sending messages.',
  noContent: 'Ochatt messenger at your service',
  startConversation: 'start conversation: ',
  startConversationTo: 'start conversation with ',
  conversation: 'chat',
  themeText: 'setting',
  languages: 'languages',
  search: 'search',
  errorRequired: 'this field is required',
  themeArray: [
    {
      color: 'white',
      text: 'pink',
    },
    // { color: 'black', text: 'black' },
    { color: 'green', text: 'green' },
    { color: 'blue', text: 'blue' },
  ],
  time: {
    some: 'a few',
    seconds: ' seconds ago',
    minutes: '  minutes ago ',
    hours: '  hours ago',
    days: '  days ago',
    weeks: '  weeks ago',
    years: ' years ago ',
  },
  name: 'OChatt',
  description:
    'Step into our chat app and unlock a new dimension of communication.  Chat, connect, and create memorable conversations.',
  appTitle: 'OChatt',
  login: {
    description: 'Enter your user Information to enter',
    toSignup: {
      description: 'Do not have an account ?',
      button: 'Sign up',
    },
    title: 'login',
    text: 'To use the messenger, please log in to your account.',
    formButton: 'enter',
    mobile: 'Phone Number',
    mobileError: 'phone number is wrong',
    mobilePlaceHolder: 'example: 9xxxxxxxx',
    password: 'password',
    passwordError: 'password is wrong',
    forgetButton: ' forget your password? ',
    createAccount: {
      description:
        'Register in OChatt to use OChatt facilities such as uploading videos, leaving comments, etc.',
      title: 'enter OChatt',
      button: 'create Account',
    },
  },
  replyToUser: 'reply to ',
  replyToMessage: 'reply to this message',
  toolbar: {
    exit: 'exit',
    fileIcon: 'file',
    chatIcon: 'chat',
    theme: {
      title: 'choose Theme',
    },
    language: {
      title: 'choose language',
    },
  },
  userDashboard: [
    {
      id: 1,
      name: 'upload',
    },
    {
      id: 2,
      name: 'videos',
    },
  ],
  chatPage: {
    you: 'you',
    navTitle: 'active users',
    footer: {
      InputPlaceHolder: 'message text',
      notConnectText: 'enter your account to send your message',
      sendButton: 'send',
      uploadButton: 'upload',
    },
  },
  userMessage: {
    delete: 'is deleted from group',
    left: 'left the group',
    add: 'joined the group',
  },
  chatFooter: {
    invalidType: 'invalid file',
    unBlock: 'unBlock',
  },
  groupMember: {
    owner: 'Group owner',
  },
  groupMemberMore: [
    {
      id: 1,
      chosen: 'promote to admin',
      icon: <AppIcons.AdminIcon fill={'#000'} />,
      notChosen: 'Dismiss admin',
    },
    {
      id: 2,
      chosen: 'delete',
      icon: <AppIcons.deleteIcon fill={'#000'} />,
      notChosen: 'delete',
    },
  ],
  chatBar: {
    userMore: [
      {
        id: 1,
        chosen: 'pin',
        notChosen: 'unPin',
        icon: <AppIcons.pinIconSetting fill={'#000'} className={`moreBox`} />,
      },
      {
        id: 2,
        chosen: 'delete',
        notChosen: 'delete',
        icon: <AppIcons.deleteIcon fill={'#000'} className={`moreBox`} />,
      },
      {
        id: 8,
        chosen: 'mute',
        icon: (
          <AppIcons.muteIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'unmute',
        notchosenIcon: (
          <AppIcons.unMuteIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
      },
      // {
      //   id: 3,
      //   chosen: 'مسدود کردن',
      //   icon: <AppIcons.BlockIcon fill={'#000'} />,
      //   notChosen: 'حذف بلاک',
      // },
      {
        id: 3,
        chosen: 'block',
        icon: <AppIcons.BlockIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'unBlock',
      },
      {
        id: 4,
        chosen: 'edit',
        icon: (
          <AppIcons.EditIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'edit',
      },
      {
        id: 5,
        chosen: 'leave group',
        icon: (
          <ToolbarIcons.ExitIcon
            width={'14px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'leave group',
      },
      {
        id: 6,
        chosen: 'group member',
        icon: <AppIcons.GroupIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'group member',
      },
      {
        id: 7,
        chosen: 'clear history',
        icon: <AppIcons.ClearHistoryIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'clear History',
      },
      // { id: 3, text: 'share', icon: <AppIcons.DownloadIcon /> },
    ],
  },
  setting: {
    more: [
      {
        id: 1,
        chosen: 'file',
        icon: (
          <ToolbarIcons.FileIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 5,
        chosen: 'edit profile',
        icon: (
          <ToolbarIcons.EditProfileIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 3,
        chosen: 'setting',
        icon: (
          <ToolbarIcons.SettingsIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: '4',
        chosen: 'create group',
        icon: (
          <AppIcons.GroupIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
          />
        ),
      },
      {
        id: 2,
        chosen: 'exit',
        icon: (
          <ToolbarIcons.ExitIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
    ],
  },
  footerMoreBox: [
    { id: 1, name: 'User sharing', icon: <AppIcons.userShareIcon /> },
  ],
  personalInfoModal: {
    title: 'name',
    username: 'username',
    groupname: 'group name',
    description: 'description',
    users: 'users',
    submit: 'submit',
    edit: 'edit',
    delete: 'delete',
    placeholder: 'write here ...',
    introTitleAdd: 'add members to group',
    introTextAdd: 'Add people to the group and communicate with them',
    introTitleEdit: 'edit group',
    introTextEdit: 'Edit name, photo, group members and notes.',
  },
  group: {
    createGroup: 'Create Group',
    editGroup: 'Edit Group',
  },
  noInfoFound: 'no info found !',
  shareUserHeader: 'User sharing',
  forwardHeader: 'send to',
  newMessage: 'new message',
  newFile: ' new file',
  countryCode: {
    error: 'your country is not supported',
    code: 'code',
    placeholder: '98',
  },
  signup: {
    mobile: {
      title: 'Step 1 / 2: enter mobile number',
      description: 'Enter your mobile phone number to register.',
      button: 'continue',
      input: {
        placeholder: 'Example: 9xxxxxxxxx',
        title: ' mobile ',
        error: 'The mobile phone is incorrect',
      },
    },
    code: {
      title: 'Step 2 / 2: Enter the verification code',
      description: 'Enter the code sent to your mobile phone.',
      button: 'continue',
      input: {
        placeholder: 'Example: 9xxxxxxxxx',
        title: 'submission code',
        error: 'Enter the received code as a four-digit number.',
      },
      resend: ' Resend code',
    },
    success: {
      title: 'Congratulations.',
      description: 'Your registration is complete. welcome. ',
      button: 'enter',
    },
  },
  forgetPassword: {
    mobile: {
      title: 'Step 1/2: enter mobile number',
      description: 'Enter your mobile phone number to change your password.',
      button: 'continue',
      input: {
        placeholder: 'Example: 9xxxxxxxxx',
        title: ' mobile ',
        error: 'The mobile phone is incorrect',
      },
    },
    code: {
      title: 'Step 2/2: Enter the sent code',
      description: 'Enter the code sent to your mobile phone.',
      button: 'submit',
      input: {
        placeholder: 'Example: 9xxxxxxxxx',
        title: 'forget password code',
        error: 'Enter the received code as a four-digit number.',
      },
    },
    success: {
      title: 'Password changed successfully.',
      description: 'The new password has been sent to your mobile number.',
      button: 'enter ',
    },
  },
  changePassword: {
    prePass: {
      title: 'Previous password',
      error: 'Enter the previous password.',
    },
    newPass: {
      title: 'New password',
      error: 'Enter the new password.',
    },
    reNewPass: {
      title: 'Repeat the new password',
      error: 'Re-enter the new password.',
    },
    notMatch: 'Password and Confirm password does not match.',
    submit: 'submit',
  },
  haveAccount: {
    title: 'Do you have an account?',
    button: 'login',
  },
  forwarded: 'forwarded',
  uploadVideo: {
    noFileUploaded: 'No file is uploaded.',
    isUploading: 'uploading ...',
    videoIsReady: 'video is ready.',
    from: 'from',
    megaByte: 'Mb',
    proccessing: 'video is being prepared',
    chooseCover: ' choose cover image',
    chooseCoverError: 'choose cover image',
    uploadImage: '  upload image',
    uploadedImage: ' uploaded image',
    empty: 'empty',
    creating: 'creating',
    submit: 'submit',
    videoForm: {
      titleInput: 'video title (required)',
      titleError: 'this field is required.',
      titlePlaceholder: 'enter video title',
      contentInput: 'description (required)',
      contentError: 'enter video description',
      contentPlaceholder: 'enter video description',
      tagTitle: ' add tag ',
      tagError: 'this field is required.',
      tagPlaceholder: ' add tag ',
      tag: 'tag',
      addTag: 'Add',
    },
  },
};
export default en;
